import { log } from '@intigral/utils/lib/logger';

export class Container {
    private static instance: Container;
    private dependencies: Map<string, any> = new Map();

    private constructor() {
        // Private constructor to prevent direct construction calls with the `new` operator.
    }

    static getInstance(): Container {
        if (!Container.instance) {
            Container.instance = new Container();
        }
        return Container.instance;
    }

    register<T>(key: string, instanceOrOptions: T | { useClass: new (...args: any[]) => T }): void {
        if (!this.dependencies.has(key)) {
            if (instanceOrOptions && typeof instanceOrOptions === 'object' && 'useClass' in instanceOrOptions) {
                // If options are provided, create an instance of the class
                const instance = new instanceOrOptions.useClass();
                this.dependencies.set(key, instance);
            } else {
                // Otherwise, assume it's an instance
                this.dependencies.set(key, instanceOrOptions);
            }
        }
    }

    resolve<T>(key: string): T {
        const dependency = this.dependencies.get(key);
        if (!dependency) {
            throw new Error(`Dependency ${key} not found`);
        }
        return dependency;
    }
}

export const container = Container.getInstance();
